
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import MobileHeader from "../../components/header/MobileHeader";
import Footer from "../../components/footer";
import Gotop from "../../components/gotop";
import NonLoginHeader from "../../components/header/NonLoginHeader";

ApprovalProcess.propTypes = {};

function ApprovalProcess(props) {

    const [isShowMobile, setShowMobile] = useState(false);



    const handleMobile = () => {
        const getMobile = document.querySelector(".menu-mobile-popup");
        setShowMobile(!isShowMobile);
        !isShowMobile
            ? getMobile.classList.add("modal-menu--open")
            : getMobile.classList.remove("modal-menu--open");
    };

    useEffect(() => {
        const WOW = require("wowjs");
        window.wow = new WOW.WOW({
            live: false,
        });
        window.wow.init();
    }, []);

    return (
        <>
            <MobileHeader handleMobile={handleMobile} />
            <NonLoginHeader clname="act1" handleMobile={handleMobile} />
            {/* <Footer /> */}
            <div className="pt-70">
            <Gotop />
            </div>
        </>
    );
}

export default ApprovalProcess;
